import React from 'react';
import { Guide } from 'types/guide';
import { GuideOrder, getGuideOrderDirection } from 'helpers/guideSort';
import DataGridList from 'components/data-grid/DataGridList';
import RowActionButton from 'components/data-grid/RowActionButton';
import StatusBadge from 'components/data-grid/StatusBadge';
import { guideTableTemplate } from '../../template/guideTableTemplate';
import GuideMenu from '../menu/GuideMenu';
import { useGuide } from '../../hooks/useGuide';

type GuideListTableProps = {
  guides: Guide[];
  handleSort(id: string): void;
  order: GuideOrder | null;
};

const GuideListTable: React.FC<GuideListTableProps> = ({ guides, handleSort, order }) => {
  const { anchorEl, setAnchorEl, setSelectedGuide } = useGuide();

  return (
    <>
      {anchorEl && <GuideMenu anchorEl={anchorEl} />}

      <DataGridList
        template={guideTableTemplate}
        rows={guides}
        getRowId={row => row.id}
        renderCells={{
          action: guide => (
            <RowActionButton
              onOpen={anchor => {
                setAnchorEl(anchor);
                setSelectedGuide(guide);
              }}
            />
          ),
          formattedStatus: guide => <StatusBadge status={guide.status} label={guide.formattedStatus ?? ''} />,
        }}
        serverSort={{ getDirection: originalId => getGuideOrderDirection(originalId, order), onSort: handleSort }}
        fileName="guias"
        sheetName="Guias"
      />
    </>
  );
};

export default GuideListTable;
